import { useApi } from "@lending/lib/api";

interface UseDefaultCarImageQueryParams {
  year?: number | null;
  make: string;
  model: string;
  trim?: string;
  enabled?: boolean;
}

function useDefaultCarImageQuery({
  year,
  make,
  model,
  trim,
  enabled = true,
}: UseDefaultCarImageQueryParams) {
  const $api = useApi();

  return $api.useQuery(
    "get",
    "/v2/lending/car_data/default_car_image/",
    {
      params: {
        query: { ...(year && { year }), make, model, ...(trim && { trim }) },
      },
    },
    { enabled }
  );
}

export { useDefaultCarImageQuery };
